import { render } from "./Background.vue?vue&type=template&id=d7e4bbd0&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=d7e4bbd0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e4bbd0"]])

export default __exports__